import { createLucideIcon } from "lucide-react";

export const CloudUpload = createLucideIcon(
    "CloudUpload",
    [
        // ... (your existing paths here) ...
        [
            "path",
            {
                d: "M12.4981 15.3945C12.8006 15.3657 13.1073 15.3509 13.4173 15.3509C15.5751 15.3509 17.5664 16.0654 19.1683 17.2711",
                key: "x6mxi4",
            },
        ],
        [
            "path",
            {
                d: "M12.4981 15.3945C7.6366 15.858 3.834 19.96 3.834 24.9518C3.834 29.5967 7.1264 33.4711 11.5007 34.3607",
                key: "3y7140",
            },
        ],
        [
            "path",
            {
                d: "M23.0006 24.9167C21.6585 24.9167 19.1511 28.7391 18.209 29.7084",
                key: "1ggii4",
            },
        ],
        [
            "path",
            {
                d: "M23.0006 24.9167C24.3428 24.9167 26.8502 28.7391 27.7923 29.7084",
                key: "gy1klb",
            },
        ],
        [
            "path",
            {
                d: "M23.0006 24.9167L23.0007 40.25",
                key: "bqh2ja",
            },
        ],
        [
            "path",
            {
                d: "M33.4993 17.2712C33.3034 19.4495 32.4472 21.4372 31.1328 23.0316",
                key: "d4l7eh",
            },
        ],
        [
            "path",
            {
                d: "M33.4993 17.2712C33.5137 17.2711 33.528 17.2711 33.5423 17.2711C38.3058 17.2711 42.1673 21.1397 42.1673 25.9119C42.1673 30.3596 38.8131 34.0224 34.5007 34.5",
                key: "3hp9mi",
            },
        ],
        [
            "path",
            {
                d: "M33.4993 17.2712C33.5278 16.9549 33.5423 16.6347 33.5423 16.311C33.5423 10.4783 28.8227 5.75 23.0007 5.75C17.4869 5.75 12.9618 9.991 12.4981 15.3945",
                key: "5oxhw5",
            },
        ],
    ],
);
